module.exports = __webpack_public_path__ + "static/media/MOTOR.74070df5.png";